<p-tabView orientation="right" (onChange)="selectTab($event)" [activeIndex]="index">
    <p-tabPanel header="Site details">
        <acabim-admin-edit-site-address
            #editaddress
            *ngIf="selectedSite !== undefined else loadingView"
            [_currentSite]="selectedSite"
            (update)="onUpdate($event)">
        </acabim-admin-edit-site-address>
    </p-tabPanel>
    <p-tabPanel header="Projects on site" cache="false">
        <ng-template pTemplate="content">
            <acabim-admin-projects
                #projects
                [_currentSite]="selectedSite"
                (update)="onUpdate($event)">
            </acabim-admin-projects>
        </ng-template>
    </p-tabPanel>
</p-tabView>


<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>
